module.exports = {
    help: {
        pages: 4,
        pageNameFormat: "res/help/page_%d.jpg",
        priceFontName: "price-font",
        // backgroundMusic: "res/sounds/help/ambient",
        click:"res/sounds/help/click",
        pricetable: [
            {
                symbol:0,
                wins:[5,4,3,2],
                position:{x:909, y:153},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:1,
                wins:[5,4,3,2],
                position:{x:587, y:224},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:2,
                wins:[5,4,3],
                position:{x:909, y:308-10},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:3,
                wins:[5,4,3],
                position:{x:263, y:310-10},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:4,
                wins:[5,4,3],
                position:{x:587, y:378},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:5,
                wins:[5,4,3],
                position:{x:909, y:446-20},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:6,
                wins:[5,4,3],
                position:{x:263, y:449-20},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:7,
                wins:[5,4,3],
                position:{x:263, y:588-30},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:8,
                wins:[5,4,3],
                position:{x:587, y:517},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:9,
                wins:[5,4,3],
                position:{x:909, y:588-30},
                offset:{width:0, height:23},
                align:'center'
            },
            {
                symbol:10,
                wins:[5,4,3,2],
                position:{x:263, y:154},
                offset:{width:0, height:23},
                align:'center'
            }
        ]
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 20
// module chunks = 0